<template>
  <div>
    <h2>
      <el-button class="pull-right"
                 v-if="canAdd()"
                 @click="showDialog()"
                 type="primary">Nuevo</el-button>
      Provisiones
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">

      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="Nombre">
        </el-table-column>
        <el-table-column
          width="100">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              v-if="!canUpdate() && canShow()"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)">
              <i class="fa fa-eye"></i>
            </el-button>
            <el-button
              v-if="canDelete()"
              type="danger"
              size="mini"
              @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item label="Nombre" prop="name">
          <el-input v-model="form.name" :disabled="canEditToSave()" ></el-input>
        </el-form-item>
      </el-form>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
            <ul>
              <li v-for="item in error.errors">{{ item[0] }}</li>
            </ul>
          </p>
        </div>
      </div>
      <el-alert
        v-if="success"
        title="Se ha guardado exitosamente."
        type="success">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary"
                   v-if="!canEditToSave()"
                   :loading="processing"
                   @click="save()">Guardar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'

  export default {
    name: 'provision-list',
    extends: BaseCrud,
    components: {
      AppTable
    },
    data () {
      return {
        baseUrl: baseApi + '/provisions',
        basePermission: 'provisions',
        provisions: [],
        form: {
          name: ''
        },
        rules: {
          name: [
            { required: true, message: 'El nombre es requerido', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
    },
    mounted () {
      this.$http.get(baseApi + '/provisions')
        .then(
          (res) => {
            this.provision = res.body.map((item) => {
              item.id = item.id.toString()
              return item
            })
          }
        )
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/provisions/Provision.vue